import HttpApiDrive from "@/services/http/api-drive";
import deviceInfos from "@/services/context/device-infos";
import cookieService from "@/services/storage/cookie.client";

export default defineNuxtPlugin(() => {
  const apiDrive = new HttpApiDrive();
  const conf = useRuntimeConfig();
  const headers = process.server ? useRequestHeaders() : null;

  const userAgent = process.server
    ? headers["user-agent"]
    : navigator.userAgent;
  const browser = userAgent
    ? deviceInfos.getBrowser(userAgent)
    : {
        version: "0",
        name: "Unknow"
      };
  const screen = {
    height: process.server ? 0 : window.screen.height,
    width: process.server ? 0 : window.screen.width
  };
  apiDrive.setAppSignature(
    `BROWSER;WEB;${browser.version};;${conf.public.VERSION};1;2;${browser.name};${screen.height};${screen.width}`
  );

  apiDrive.setConfig(conf.public.API_DRIVE_URL, conf.public.API_DRIVE_TIMEOUT);

  apiDrive.setRequestInterceptor((config) => {
    if (process.server) {
      if (headers["x-real-ip"]) {
        config.headers["X-Forwarded-For"] = headers["x-real-ip"];
      }
      if (headers["user-agent"]) {
        config.headers["X-User-Agent"] = headers["user-agent"];
      }
      if (headers["x-imperva-cora-asn"]) {
        config.headers["x-imperva-cora-asn"] = headers["x-imperva-cora-asn"];
      }
      if (headers["x-imperva-country-hors-zone"]) {
        config.headers["x-imperva-country-hors-zone"] =
          headers["x-imperva-country-hors-zone"];
      }
      if (headers["app-partner"]) {
        config.headers["app-partner"] = headers["app-partner"];
      }
    }

    if (process.client) {
      if (cookieService.get("reese84")) {
        config.headers["X-D-Token"] = cookieService.get("reese84");
      }
    }

    if (conf.public.IS_DEV) {
      config.headers[conf.public.DEVONLY_ABP_HEADER] =
        conf.public.DEVONLY_ABP_VALUE;
    }

    return config;
  });

  return {
    provide: {
      apiDrive
    }
  };
});
